import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { notificationService } from "../services/notificationService";

const PAGE_SIZE = 10;

const Notification = ({ t, onMarkRead, onClose }) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPreviousPage, setHasPreviousPage] = useState(false);
  useEffect(() => {
    fetchUnread(1);
  }, []);

  const fetchUnread = async (page) => {
    setLoading(true);
    try {
      const result = await notificationService.getAllAsync({
        pageNumber: page,
        pageSize: PAGE_SIZE,
        orderBy: "createdAt",
        orderDirection: "desc",
        includeDeleted: false,
        isRead: false,
      });
      setItems(result?.items || []);
      setPageNumber(result?.pageNumber ?? page);
      setHasNextPage(result?.hasNextPage ?? false);
      setHasPreviousPage(result?.hasPreviousPage ?? false);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleItemClick = (item) => {
    onClose?.();
    navigate(`/notification-details/${item.id}`);
  };

  const getInitials = (name = "") =>
    name
      .trim()
      .split(" ")
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase() || "")
      .join("");

  return (
    <section className="section-notification" style={{ right: 0 }}>
      <div className="notification-header">
        {t("notifications")}
        <i
          className="fas fa-times cursor-pointer float-end"
          onClick={onClose}
          style={{ fontSize: "14px" }}
        />
      </div>
      <div className="notification-body">
        {loading ? (
          <div className="notification-item justify-content-center">
            <span className="spinner-border spinner-border-sm" />
          </div>
        ) : items.length > 0 ? (
          items.map((item) => (
            <div
              key={item.id}
              className="notification-item cursor-pointer"
              onClick={() => handleItemClick(item)}
            >
              <div className="notificatin-box">{getInitials(item.userName)}</div>
              <div className="notification-content">
                <div className="notification-title">{item.userName}</div>
                <div className="notification-message">{item.message}</div>
              </div>
            </div>
          ))
        ) : (
          <div className="notification-item">
            <div className="notification-content">
              <div className="notification-message text-center w-100">
                {t("noNotifications")}
              </div>
            </div>
          </div>
        )}

        {(hasPreviousPage || hasNextPage) && (
          <div className="d-flex justify-content-between align-items-center px-3 py-2 border-top">
            <button
              className="btn btn-sm btn-outline-secondary"
              disabled={!hasPreviousPage || loading}
              onClick={() => fetchUnread(pageNumber - 1)}
            >
              <i className="fas fa-chevron-left" />
            </button>
            <small className="text-muted">{pageNumber}</small>
            <button
              className="btn btn-sm btn-outline-secondary"
              disabled={!hasNextPage || loading}
              onClick={() => fetchUnread(pageNumber + 1)}
            >
              <i className="fas fa-chevron-right" />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Notification;
